module.exports = __webpack_public_path__ + "img/logo-icon.03e5a535.svg";